import { useContext } from 'react';
import { useQueryClient } from '@tanstack/react-query';
import { AdminTableContext } from '../../AdminTable';
import { AdminProfessionals, AdminRepresentatives } from '@platform/client';
import { Modal } from '@platform/components';

export const VerifyEmailModal = (props: { userId: number; onClose: () => void }) => {
  const { adminQueryOptionsV2 } = useContext(AdminTableContext);
  const queryClient = useQueryClient();
  const verifyEmailMutator = AdminProfessionals.useUpdateEmailVerification({
    mutation: {
      onError: () => {
        alert('Error verifying email');
      },
      onSuccess: () => {
        queryClient.invalidateQueries({
          queryKey: AdminProfessionals.getGetAdminProfessionalsQueryKey({
            ...adminQueryOptionsV2,
          }),
        });
        queryClient.invalidateQueries({
          queryKey: AdminRepresentatives.getGetRepresentativesQueryKey({
            ...adminQueryOptionsV2,
          }),
        });
        props.onClose();
      },
    },
  });

  return (
    <Modal
      title='Verify Email'
      isOpen={true}
      onClose={props.onClose}
      headerDivision='divider'
      variant='dialog'
      primaryCTA={{
        text: 'Verify',
        callback: () => {
          verifyEmailMutator.mutate({
            data: {
              userId: props.userId,
              verified: true,
            },
          });
          props.onClose();
        },
        buttonVariant: 'primary',
      }}
      secondaryCTA={{
        text: 'Cancel',
        callback: props.onClose,
      }}
      ignoreExtraPadding
    >
      <>
        <span>This email has not been verified by the user.</span>
      </>
    </Modal>
  );
};
